import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {
  EtsyBulkCreateCsvItemInput,
  MutationCreateQueueJobArgs,
  QueueJob,
  QueueJobInput,
} from '../__generated__/resolvers-types';

export const SET_ETSY_BULK_CREATE_CSV_MUTATION = gql`
  mutation CreateQueueJob($job: QueueJobInput!) {
    createQueueJob(job: $job) {
      id
      status
      expireTimestamp
      creationTimestamp
      lastUpdateTimestamp
      etsyBulkCreateCsv {
        shopRecordId
        items {
          id
          status
          error
        }
      }
    }
  }
`;

/**
 * bulk upload etsy product where each folder is a product
 * @returns
 */
export default function useSetEtsyBulkCreateCsv() {
  const [createBulkEtsyCreateCsvJob, {data, loading, error}] = useMutation<QueueJob, MutationCreateQueueJobArgs>(
    SET_ETSY_BULK_CREATE_CSV_MUTATION,
  );

  return {
    createBulkEtsyCreateCsvJob: (shopRecordId: string, items: EtsyBulkCreateCsvItemInput[]) => {
      const job: QueueJobInput = {
        etsyBulkCreateCsv: {
          shopRecordId,
          items,
        },
      };
      return createBulkEtsyCreateCsvJob({
        variables: {job},
      });
    },
    data,
    loading,
    error,
  };
}
